import { Heart } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function HeartBadge({ count, testId = "heart-badge" }) {
  if (!count) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="climber-badge inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-extrabold text-white bg-gradient-to-r from-rose-600 to-pink-400 shadow-md shadow-rose-300/60 ring-1 ring-rose-300 active:scale-95 transition-transform">
          <Heart className="w-3.5 h-3.5 fill-white heart-beat" /> Herz-Kette{count > 1 ? ` ×${count}` : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 rounded-2xl text-sm text-slate-600" data-testid={`${testId}-info`}>
        <p className="font-bold text-slate-900">💖 Teil der Herz-Kette</p>
        <p className="mt-1">War {count === 1 ? "schon einmal" : `schon ${count}-mal`} eine Station der Herz-Kette und hat das Herz weitergetragen.</p>
      </PopoverContent>
    </Popover>
  );
}
